module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btb-bar",
    class: {
      'btb-bar--empty': !_vm.hasJourney
    }
  }, [_c('div', {
    staticClass: "btb-env"
  }, [_c('span', {
    staticClass: "btb-env-label"
  }, [_vm._v("Environment:")]), _vm._v(" "), _c('span', {
    staticClass: "btb-env-badge"
  }, [_vm._v(_vm._s(_vm.environment.toUpperCase()))])]), _vm._v(" "), (_vm.hasJourney) ? [_c('div', {
    staticClass: "btb-stepper"
  }, [_vm._l((_vm.stages), function(stage, i) {
    return [_c('div', {
      key: stage.key,
      staticClass: "btb-step",
      class: _vm.statusOf(i)
    }, [_c('span', {
      staticClass: "btb-step-dot"
    }, [(_vm.statusOf(i) === 'done') ? _c('svg', {
      attrs: {
        "width": "11",
        "height": "11",
        "viewBox": "0 0 24 24",
        "fill": "none",
        "stroke": "currentColor",
        "stroke-width": "3",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }
    }, [_c('polyline', {
      attrs: {
        "points": "20 6 9 17 4 12"
      }
    })]) : [_vm._v(_vm._s(i + 1))]], 2), _vm._v(" "), _c('span', {
      staticClass: "btb-step-label"
    }, [_vm._v(_vm._s(stage.label))])]), _vm._v(" "), (i < _vm.stages.length - 1) ? _c('div', {
      key: stage.key + '-line',
      staticClass: "btb-step-line",
      class: {
        done: i < _vm.currentIndex
      }
    }) : _vm._e()]
  }), _vm._v(" "), _c('button', {
    staticClass: "btb-mark-live",
    attrs: {
      "disabled": _vm.currentStage === 'live'
    }
  }, [_vm._v("Mark live →")])], 2), _vm._v(" "), _c('span', {
    staticClass: "btb-validate-wrap"
  }, [_c('button', {
    staticClass: "btb-validate",
    class: {
      ok: _vm.validationResult && _vm.validationResult.valid,
      err: _vm.validationResult && !_vm.validationResult.valid
    },
    attrs: {
      "disabled": _vm.validating,
      "title": "Validate this journey's structure"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('validate')
      }
    }
  }, [(!_vm.validating) ? _c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('polyline', {
    attrs: {
      "points": "20 6 9 17 4 12"
    }
  })]) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.validating ? 'Validating…' : 'Validate') + "\n      ")]), _vm._v(" "), (_vm.validationResult) ? _c('span', {
    staticClass: "btb-validate-msg",
    class: {
      ok: _vm.validationResult.valid,
      err: !_vm.validationResult.valid
    }
  }, [_vm._v(_vm._s(_vm.validationResult.message))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "btb-validate-wrap"
  }, [_c('button', {
    staticClass: "btb-promote",
    attrs: {
      "disabled": !_vm.canPromote || _vm.promoting,
      "title": _vm.canPromote ? 'Promote this journey to the Production environment' : 'Run Validate successfully before promoting'
    },
    on: {
      "click": function($event) {
        return _vm.$emit('promote')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "13",
      "height": "13",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 19V5"
    }
  }), _c('polyline', {
    attrs: {
      "points": "5 12 12 5 19 12"
    }
  })]), _vm._v("\n        " + _vm._s(_vm.promoting ? 'Saving…' : 'Promote to Production') + "\n      ")]), _vm._v(" "), (_vm.promoteResult) ? _c('span', {
    staticClass: "btb-validate-msg",
    class: {
      ok: _vm.promoteResult.success,
      err: !_vm.promoteResult.success
    }
  }, [_vm._v(_vm._s(_vm.promoteResult.message))]) : _vm._e()])] : _c('span', {
    staticClass: "btb-empty-msg"
  }, [_vm._v("No journey loaded")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-52d78d0e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/BuilderTopBar.vue
// module id = pgZv
// module chunks = 1